import {Button} from '@dropbox/dig-components/buttons';
import {FormLabel, FormRow} from '@dropbox/dig-components/form_row';
import {TextArea} from '@dropbox/dig-components/text_fields';
import {Text} from '@dropbox/dig-components/typography';
import {Stack} from '@dropbox/dig-foundations';
import {pulseUserAtom} from 'atoms/auth';
import {useAIQuick} from 'components/DSYS/editor/helpers/aiEditorHooks';
import {Layout} from 'components/DSYS/Layout';
import {Title} from 'components/DSYS/Title';
import {ROUTE_PATHS} from 'constant';
import {isSuperUser} from 'helpers/utils';
import {useDocumentTitle} from 'hooks/useDocumentTitle';
import {useAtomValue} from 'jotai';
import {useState} from 'react';
import {useNavigate} from 'react-router';

export const AdminAIPrompt = () => {
  const pulseUser = useAtomValue(pulseUserAtom);
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState('');
  const [data, setData] = useState('');
  const {generate, generateData, isGenerating, clearData} = useAIQuick();

  useDocumentTitle('AI prompt');

  if (!pulseUser) {
    return null;
  }

  if (!isSuperUser(pulseUser)) {
    navigate('/');
    return null;
  }

  const handleSubmit = async () => {
    clearData();
    await generate(prompt, data);
  };

  return (
    <Layout.Container
      breadcrumb={[
        {children: 'Admin', to: ROUTE_PATHS.ADMIN},
        {children: 'AI prompt', to: ROUTE_PATHS.ADMIN_AI_PROMPT},
      ]}
    >
      <Stack gap="24">
        <Title size={24}>AI prompt</Title>
        <FormRow>
          <FormLabel htmlFor="admin-ai-prompt-prompt">Prompt</FormLabel>
          <TextArea
            id="admin-ai-prompt-prompt"
            value={prompt}
            onChange={(e) => setPrompt(e.currentTarget.value)}
            placeholder="Instructions for the model (e.g. Rephrase the following text, Summarize, …)"
            rows={4}
          />
        </FormRow>
        <FormRow>
          <FormLabel htmlFor="admin-ai-prompt-data">Content</FormLabel>
          <TextArea
            id="admin-ai-prompt-data"
            value={data}
            onChange={(e) => setData(e.currentTarget.value)}
            placeholder="Text or markdown to send with the prompt"
            rows={8}
          />
        </FormRow>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={isGenerating || !prompt.trim() || !data.trim()}
        >
          {isGenerating ? 'Submitting…' : 'Submit'}
        </Button>
        {(isGenerating || generateData) && (
          <Stack gap="8">
            <Text isBold>Response</Text>
            <TextArea
              id="admin-ai-prompt-response"
              value={generateData ?? ''}
              readOnly
              rows={12}
              style={{resize: 'none'}}
            />
          </Stack>
        )}
      </Stack>
    </Layout.Container>
  );
};
